import { useQuery } from 'react-query'
import { sub, getTime } from 'date-fns'
import { keyBy } from 'lodash'

import { apiFetch } from 'lib/action-helpers'
import { usageServicePaths as paths, ORG_INGESTION_SUMMARY } from './index'
import { useOrganization } from 'hooks/context/organization-context'

const getOrganizationDataIngestionSummary = async (organization, { from, until }) => {
  const body = JSON.stringify({ from, until })
  const data = await apiFetch(paths.organizationDataIngestionSummary(organization), { method: 'POST', body })

  return keyBy(data, (accountUsage) => accountUsage?.account?.id)
}

export const useOrgIngestionSummaryQuery = (payload) => {
  const { organization } = useOrganization()

  const from = payload?.start || getTime(sub(new Date(), { days: 30 }))
  const until = payload?.end || Date.now()

  return useQuery(
    [...ORG_INGESTION_SUMMARY, organization?.id],
    () => getOrganizationDataIngestionSummary(organization?.id, ({ from, until })),
    {
      staleTime: Infinity,
      enabled: !!organization?.id
    }
  )
}
